/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { Model } from '@okta/courage';
import BaseLoginModel from './BaseLoginModel';
export default BaseLoginModel.extend({
  constructor: function(options) {
    this.settings = options && options.settings;
    Model.apply(this, arguments);
  },
  loginWithActivationToken: function(activationToken) {
    return this.startTransaction(function(authClient) {
      return authClient.signInWithCredentials({ token: activationToken });
    });
  },
});
